import React, { useEffect } from "react";
import Layout from "../components/Layout";
import Hero from "../components/Hero";
import PageSeoContent from "../components/PageSeoContent";

const Contact = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <Layout>
      <Hero title="Contact us" />
      <PageSeoContent variant="contact" />
      <section className="contact-sec wow fadeInUp" data-wow-delay="0.2s">
        <div className="container">
          <div className="row">
            <div
              className="col-lg-6 col-xl-6 col-md-6 wow fadeInUp mb-lg-4 mb-xl-0"
              data-wow-delay="0.3s"
            >
              <div className="details adrss">
                <div className="icon">
                  <i className="fas fa-map-marked-alt"></i>
                </div>
                <div className="cnt-sec">
                  <h4 className="title-24 white-text">HEAD OFFICE</h4>
                  <p className="p-20 white-text">
                    7th Floor, Esperanca, Shahid Bhagat Singh Road Near Electric
                    House, Colaba, Mumbai Maharashtra 400001
                  </p>
                </div>
              </div>
            </div>
            <div
              className="col-lg-6 col-xl-3 col-md-6 wow fadeInUp"
              data-wow-delay="0.5s"
            >
              <div className="details">
                <div className="icon">
                  <i className="fas fa-phone-alt"></i>
                </div>
                <div className="cnt-sec">
                  <h4 className="title-24 white-text">PHONE</h4>
                  <a className="p-20 white-text" href="tel:+91 9819955551">
                    +91 9819955551
                  </a>
                </div>
              </div>
            </div>
            <div
              className="col-lg-6 col-xl-3 wow fadeInUp"
              data-wow-delay="0.6s"
            >
              <div className="details">
                <div className="icon">
                  <i className="fas fa-paper-plane"></i>
                </div>
                <div className="cnt-sec">
                  <h4 className="title-24 white-text">EMAIL</h4>
                  <a
                    className="p-20 white-text"
                    href="mailto::info@azzirevents.com"
                  >
                    info@azzirevents.com
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="contact-map-sec wow fadeInUp" data-wow-delay="0.7s">
        <div className="">
          <div className="contact-map">
            <div
              className="mapouter"
              style={{
                position: "relative",
                textAlign: "right",
                height: "500px",
                width: "100%",
              }}
            >
              <div
                className="gmap_canvas"
                style={{
                  overflow: "hidden",
                  background: "none!important",
                  height: "100%",
                  width: "100%",
                }}
              >
                <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d7548.543807141961!2d72.82449129007145!3d18.919355187037944!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7d1c11baeb805%3A0xc3be8b96beb551ed!2sElectric%20House!5e0!3m2!1sen!2sin!4v1760434365209!5m2!1sen!2sin" height="450" style={{ width: '100%', border: 0 }} allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>

              </div>
            </div>
          </div>
        </div>
        {/* <div className="row no-gutters">
          <div className="col-lg-4 offset-lg-2">
            <div className="contact-form">
              <div className="form-sec">
                <form>
                  <div className="title-sec">
                    <h3 className="title-30 white-text">Contact</h3>
                  </div>
                  <div className="row">
                    <div className="col-lg-6">
                      <label>Name</label>
                      <input
                        type="text"
                        name=""
                        placeholder="name"
                        className="form-control"
                      />
                    </div>
                    <div className="col-lg-6">
                      <label>E-Mail</label>
                      <input
                        type="email"
                        name=""
                        placeholder="Type your email"
                        className="form-control"
                      />
                    </div>
                    <div className="col-lg-12">
                      <label>Subject</label>
                      <input
                        type="text"
                        name=""
                        placeholder="subject"
                        className="form-control"
                      />
                    </div>
                    <div className="col-lg-12">
                      <label>Message</label>
                      <textarea className="form-control"></textarea>
                    </div>
                    <div className="col-lg-12">
                      <div className="send-btn">
                        <button>Send Request</button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="contact-map">
                <div
                  className="mapouter"
                  style={{
                    position: "relative",
                    textAlign: "right",
                    height: "500px",
                    width: "100%",
                  }}
                >
                  <div
                    className="gmap_canvas"
                    style={{
                      overflow: "hidden",
                      background: "none!important",
                      height: "100%",
                      width: "100%",
                    }}
                  >
                    <iframe
                      title="gmap_canvas"
                      src="https://maps.google.com/maps?q=636+5th+Ave%2C+New+York&t=&z=13&ie=UTF8&iwloc=&output=embed"
                      style={{
                        width: "100%",
                        height: "100%",
                        border: "none",
                        overflow: "hidden",
                        margin: 0,
                      }}
                    ></iframe>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div> */}
      </section>
      {/* on className="content-recommendation-sec section-gap">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-10 text-center">
              <h2 className="recommendation-title">
                Azzir – Contact for Events &amp; Nightlife
              </h2>
              <p className="recommendation-text mb-3">
                Have questions about clubs, events, artists, lounges, or nightlife experiences? Our team is here to help. Whether you need support, want to list your event, partner with Azzir, or have a business enquiry, we'd love to hear from you.
              </p>
              <p className="recommendation-text fw-bold">
                Contact Azzir today and discover how we can help you connect with the best events and entertainment near you.
              </p>
            </div>
          </div>
        </div>
      </section> */}
      <a href="#" className="back-to-top">
        <i className="fa fa-chevron-up"></i>
      </a>
    </Layout>
  );
};

export default Contact;
